import { useNavigate } from "react-router-dom";
import CustomButton from "../../../../../components/CustomButton";
import SvgIcon from "../../../../../helpers/SvgIcon";
import { useAppDispatch } from "../../../../../redux/hooks";
import { FleetDocumentsDataInterface } from "../../../../../redux/interfaces/fleet.interface";
import { setFleetDocumentData } from "../../../../../redux/reducer/fleet.reducer";
import { fetchDeleteDocument } from "../../../../../redux/api/fleet.api";
import usePermissions from "../../../../../router/usePermissions";
import userRoles from "../../../../../constants/userRoles";
import { getCurrentDate } from "../../../../../utils/dateAndTime";

function FleetDocumentsActionButton({
  crudData,
  itemId,
}: {
  itemId: string;
  crudData: FleetDocumentsDataInterface;
  tableContext: any;
}) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isAuthorized } = usePermissions();

  const { CAR_DOCUMENT_EDIT_PERMISSION, CAR_DOCUMENT_DELETE_PERMISSION } = {
    CAR_DOCUMENT_EDIT_PERMISSION: isAuthorized(userRoles.CAR_DOCUMENT_EDIT),
    CAR_DOCUMENT_DELETE_PERMISSION: isAuthorized(userRoles.CAR_DOCUMENT_DELETE),
  };

  const handleEdit = () => {
    dispatch(setFleetDocumentData(crudData));
    navigate(`edit?nrauto=${crudData.nrauto}`);
  };

  const handleDelete = () => {
    dispatch(fetchDeleteDocument({ id: itemId, carId: crudData.id_auto }));
  };

  const today = getCurrentDate();
  const validDocument = crudData.doc_ts_stop > today;

  return (
    <>
      {validDocument && (
        <div>
          {CAR_DOCUMENT_EDIT_PERMISSION && (
            <CustomButton
              variant="contained"
              className="mt-1 me-1"
              tooltipTitle="Editeaza"
              onClick={handleEdit}>
              <SvgIcon type="EDIT" />
            </CustomButton>
          )}
          {CAR_DOCUMENT_DELETE_PERMISSION && (
            <CustomButton
              variant="contained"
              color="error"
              className="mt-1 me-1"
              tooltipTitle="Sterge"
              withConfirmationModal={{
                modalTitle: `Doriti sa stergeti acest document pentru ${crudData.denumire}?`,
                modalLeftButtonColor: "inherit",
                modalRightButtonOnClick: handleDelete,
                modalRightButtonText: "Sterge",
                modalLeftButtonText: "Anuleaza",
              }}>
              <SvgIcon type="DELETE" />
            </CustomButton>
          )}
        </div>
      )}
    </>
  );
}

export default FleetDocumentsActionButton;
